import React, { Link } from "react-router-dom";
import styled from "styled-components";

import PendingIcon from "../../assets/ordericons/Pending.svg";
import CancelledIcon from "../../assets/ordericons/Cancelled.svg";
import DeliveredIcon from "../../assets/ordericons/Delivered.svg";
import ConfirmedIcon from "../../assets/ordericons/Confirmed.svg";

const NotificationContainer = styled(Link)`
  width: 100%;
  height: auto;
  border-radius: 5px;
  cursor: pointer;
`;
const Noti = styled.div`
  width: 90%;
  height: 60px;
  padding: 9px 5% 3px 5%;
  border-radius: 5px;
  cursor: pointer;
  color: black;
  &:hover {
    background: #fafafa;
  }
`;
const NotiImg = styled.img`
  width: 40px;
  height: 40px;
  float: left;
`;
const NotiText = styled.p`
  float: right;
  width: 80%;
  margin: 0;
  padding: 0;
`;
const ShopName = styled.span`
  color: #276fb7;
`;
function Notification(props) {
  console.log("Noti", props);
  let notification = "";
  if (props.notification.notificationType == "ConfirmedOrder") {
    notification = (
      <NotificationContainer
        onClick={props.notificationHandler}
        to="/user-profile/orders/confirmed"
      >
        <Noti>
          <NotiImg src={ConfirmedIcon} alt="notiImg" loading="lazy" />
          <NotiText>
            You order no{" "}
            {props.notification.orderNo ? props.notification.orderNo : "123"}{" "}
            confirmed by <ShopName>{props.notification.shop.name}</ShopName>.
            Wait for delivery.
          </NotiText>
        </Noti>
      </NotificationContainer>
    );
  } else if (props.notification.notificationType == "DeliveredOrder") {
    notification = (
      <NotificationContainer
        onClick={props.notificationHandler}
        to="/user-profile/orders/delivered"
      >
        <Noti>
          <NotiImg src={DeliveredIcon} alt="notiImg" loading="lazy" />
          <NotiText>
            You order no{" "}
            {props.notification.orderNo ? props.notification.orderNo : "123"}{" "}
            delivered by <ShopName>{props.notification.shop.name}</ShopName>.
          </NotiText>
        </Noti>
      </NotificationContainer>
    );
  } else if (props.notification.notificationType == "CancelledOrder") {
    notification = (
      <NotificationContainer
        onClick={props.notificationHandler}
        to="/user-profile/orders/cancelled"
      >
        <Noti>
          <NotiImg src={CancelledIcon} alt="notiImg" loading="lazy" />
          <NotiText>
            You order no{" "}
            {props.notification.orderNo ? props.notification.orderNo : "123"}{" "}
            cancelled by <ShopName>{props.notification.shop.name}</ShopName>.
          </NotiText>
        </Noti>
      </NotificationContainer>
    );
  } else if (props.notification.notificationType == "PendingOrder") {
    notification = (
      <NotificationContainer
        onClick={props.notificationHandler}
        to="/merchant/orders"
      >
        <Noti>
          <NotiImg src={PendingIcon} alt="notiImg" loading="lazy" />
          <NotiText>
            You have an order from{" "}
            <ShopName>{props.notification.user.user_name}</ShopName>, accept
            your order.
          </NotiText>
        </Noti>
      </NotificationContainer>
    );
  }
  return notification;
}
export default Notification;
